import { tns } from "../vendor/tiny-slider/src/tiny-slider.js";
import "hammerjs";

const spotsClasses = ["inspiration-spot", "apartment"];
spotsClasses.forEach((spotClass) => {
  const sliderContainers = document.querySelectorAll(`.${spotClass}__slider`);
  const mobileSliders = document.querySelectorAll(
    `.${spotClass}__slider-mobile`
  );

  const initLargeSlider = () => {
    Array.from(sliderContainers).forEach((sliderItem) => {
      const prevButton = sliderItem.querySelector(
        `.${spotClass}__button--prev`
      );
      const nextButton = sliderItem.querySelector(
        `.${spotClass}__button--next`
      );

      const slides = sliderItem.querySelectorAll(`.${spotClass}__slide`);
      const slideList = sliderItem.querySelector(`.${spotClass}__list`);
      const numberOfSlides = slides.length;

      let currentSlide = 1;

      const nav = sliderItem.querySelector(`.${spotClass}__nav`);
      const navTrack = sliderItem.querySelector(`.${spotClass}__nav-track`);
      let navTrackWidth = nav.offsetWidth / numberOfSlides;
      const setNavTrackWidth = () => {
        navTrackWidth = nav.offsetWidth / numberOfSlides;
        navTrack.style.width = navTrackWidth + "px";
      };
      setTimeout(() => {
        setNavTrackWidth();
      }, 150);

      const moveNavTrack = () => {
        navTrack.style.left = navTrackWidth * (currentSlide - 1) + "px";
      };
      const checkButtons = () => {
        if (currentSlide === 1) {
          prevButton.disabled = true;
        } else {
          prevButton.disabled = false;
        }

        if (currentSlide === numberOfSlides) {
          nextButton.disabled = true;
        } else {
          nextButton.disabled = false;
        }
      };

      let translateValue = 0;
      window.addEventListener("resize", (e) => {
        if (window.innerWidth >= 992) {
          setNavTrackWidth();
          moveNavTrack();
        }
      });

      var manager = new Hammer.Manager(slideList);
      var Swipe = new Hammer.Swipe();
      manager.add(Swipe);
      var lastPosX = 0;
      var lastPosY = 0;
      var isDragging = false;

      var slideCount = slideList.children.length;

      manager.add(
        new Hammer.Pan({ direction: Hammer.DIRECTION_ALL, threshold: 2 })
      );

      var offsetWidth = 0;
      var direction;
      var currentSlidingItem = null;
      var isOnFirstSlide;
      var isOnLastSlide;

      // Set the offsetWidth of the slider
      function setOffsetWidth() {
        offsetWidth = Array.from(slides)
          .filter((slide, index) => index < currentSlide - 1)
          .reduce((cur, item) => (cur += item.offsetWidth), 0);

        currentSlidingItem = slides[currentSlide - 1];
      }

      // Listen for panstart
      manager.on("panstart", function (e) {
        isOnLastSlide = currentSlide == slides.length;
        isOnFirstSlide = currentSlide === 1;

        if (isOnLastSlide) {
          return;
        }
        setOffsetWidth();
      });

      // Move the slider in both direction
      manager.on("panleft panright", function (e) {
        direction = e.type;
        if (isOnLastSlide && direction === "panleft") {
          return;
        }
        if (isOnFirstSlide && direction === "panright") {
          return;
        }
        var panMe = offsetWidth - e.deltaX;
        slideList.style.transform = "translateX( " + panMe * -1 + "px )";
      });

      // When user stops dragging - detect where the slider should go (left, right or stand on the same element)
      manager.on("panend pancancel", function (e) {
        if (
          !direction ||
          (isOnLastSlide && direction === "panleft") ||
          (isOnFirstSlide && direction === "panright")
        ) {
          return;
        }

        const currentSlideWidth =
          currentSlidingItem.getBoundingClientRect().width;
        const minPan = currentSlideWidth / 4;
        const panned = e.distance;

        if (panned >= minPan) {
          if (direction === "panright") {
            goToPrevious();
          } else {
            goToNext();
          }
        } else {
          if (currentSlide == 1) {
            slideList.style.transform = "translateX(0px)";
          } else {
            slideList.style.transform =
              "translateX( " + offsetWidth * -1 + "px )";
          }
        }

        direction = null;
      });

      function goToNext() {
        const widthOfNextSlide = slides[currentSlide - 1].offsetWidth;
        translateValue += widthOfNextSlide;
        slideList.style.transform = `translateX(-${translateValue}px)`;
        currentSlide++;
        moveNavTrack();
        checkButtons();
        setOffsetWidth();
      }

      function goToPrevious() {
        const cur = slides[currentSlide - 2];
        if (!cur) {
          return;
        }
        const widthOfPrevSlide = slides[currentSlide - 2].offsetWidth;
        translateValue -= widthOfPrevSlide;
        slideList.style.transform = `translateX(-${translateValue}px)`;
        currentSlide--;
        moveNavTrack();
        checkButtons();
        setOffsetWidth();
      }

      nextButton.addEventListener("click", (e) => {
        e.preventDefault();
        goToNext();
      });

      prevButton.addEventListener("click", (e) => {
        e.preventDefault();
        goToPrevious();
      });
    });
  };
  const initSmallSlider = () => {
    Array.from(mobileSliders).forEach((sliderItem) => {
      const slider = tns({
        container: sliderItem.querySelector(`.${spotClass}__list`),
        items: 1,
        slideBy: 1,
        loop: true,
        gutter: 10,
        edgePadding: 40,
        viewportMax: 90,
        controls: false,
        preventScrollOnTouch: "auto",
        navPosition: "bottom",
        responsive: {
          768: {
            items: 2,
            slideBy: 2,
          },
        },
      });
    });
  };

  initLargeSlider();
  initSmallSlider();
});
